import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root',
})
export class EmpresaAlternaSavoryService {
  constructor(private gqlclient: GraphQLClient) {}

  obtenerSegunFiltro(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($codigo_comuna: Decimal, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            empresa_alterna_savory {
              obtenerSegunFiltro(filtro: { exacto: { codigo_comuna: $codigo_comuna } }, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    idempalt
                    detalle
                    idweb
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.empresa_alterna_savory.obtenerSegunFiltro;
        callback({ mensajes, respuesta });
      }
    );
  }
}
